# GraphQL fragment to get basic info about a stage goal
# within the sales automation environment.

#import "../fragments/automation-conditions-fragment.graphql"

fragment SalesAutomationStageGoal on Goal {
    id
    goalType
    stage {
        id
        name
    }
    humanReadableTitle
    humanReadableSubtitle
    conditions {
        ...Condition
    }
}
